import { render, staticRenderFns } from "./ClassXianXia.vue?vue&type=template&id=2c02b010&scoped=true&"
import script from "./ClassXianXia.vue?vue&type=script&lang=js&"
export * from "./ClassXianXia.vue?vue&type=script&lang=js&"
import style0 from "./ClassXianXia.vue?vue&type=style&index=0&id=2c02b010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02b010",
  null
  
)

export default component.exports